import MuiCardContent from '@mui/material/CardContent'
import { FC } from 'react'

import { CardContentProps } from './card-content.types'

export const CardContent: FC<CardContentProps> = ({ children, ...props }) => {
  return <MuiCardContent {...props}>{children}</MuiCardContent>
}
